import { makeUIHeading } from './internal/makeUIHeading';

/**
 * Компонет типогрфики для оформления заголовков в UI
 */
export var UIHeading1 = makeUIHeading({
  fontSize: '28px',
  lineHeight: '9u',
  letterSpacing: '-0.5px'
});

/**
 * Компонет типогрфики для оформления заголовков в UI
 */
export var UIHeading2 = makeUIHeading({
  fontSize: '22px',
  lineHeight: '7u',
  letterSpacing: '-0.5px'
});

/**
 * Компонет типогрфики для оформления заголовков в UI
 */
export var UIHeading3 = makeUIHeading({
  fontSize: '18px',
  lineHeight: '6u',
  letterSpacing: '-0.5px'
});

/**
 * Компонет типогрфики для оформления заголовков в UI
 */
export var UIHeading4 = makeUIHeading({
  fontSize: '16px',
  lineHeight: '6u',
  letterSpacing: '-0.2px'
});

/**
 * Компонет типогрфики для оформления заголовков в UI
 */
export var UIHeading5 = makeUIHeading({
  fontSize: '14px',
  lineHeight: '5u',
  letterSpacing: '-0.2px'
});

/**
 * Компонет типогрфики для оформления заголовков в UI
 */
export var UIHeading6 = makeUIHeading({
  fontSize: '12px',
  lineHeight: '4u',
  letterSpacing: '0'
});